import {
  G_LOGIN_START,
  G_LOGIN_SUCCESS,
  G_LOGIN_ERROR,
  G_LOGIN_RESET,
} from "./constant"

const initialState = {
  loading: false,
  error: "",
  isLogin: false,
  userDetails: {},
}

const GloginReducer = (state = initialState, action) => {
  switch (action.type) {
    case G_LOGIN_START:
      return {
        ...state,
        loading: true,
        error: null,
        userDetails: {}
      }
    case G_LOGIN_SUCCESS:
      localStorage.setItem("authUser", JSON.stringify(action.payload.token));
      localStorage.setItem("WWINGS_USER_TYPE", JSON.stringify(action.payload.userType));
      return {
        ...state,
        userDetails: action.payload,
        loading: false,
      }
    case G_LOGIN_ERROR:
      return {
        ...state,
        error: action.payload.message,
        loading: false,
      }
    case G_LOGIN_RESET:
      return {
        ...state,
      }
    default:
      return state
  }
}

export default GloginReducer
